<template>
    <div
      v-for="(fila,index) in options.filas"
      :key="index"
      v-bind="$attrs"
      :class="[(fila.class && String(fila.class).includes('grid')) ? '' : 'flex', fila.class]"
    >
        <div v-for="(col,indexc) in fila.cols" :key="indexc" class="flex flex-col"  :style="col.style">
            <div
              v-for="(line,indexL) in col.lines"
              :key="indexL"
              :style="line.style"
              :class="[
                (line.class?line.class:''),
                line.noRounded ? '': 'rounded-xl',
                ' my-3  dark:border-gray-800 animate-pulse  bg-gray-200 dark:bg-gray-700 aspect-[3]'
              ]">
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
defineProps<{
    classContainer?: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options: any
}>()
</script>
